import api from './data.services'
import { authService } from '.'

const emailSrv = 'email'

const getTemplatesInfo = async () => {
  try {
    const resp = await api.get(emailSrv, authService.getToken())

    if (!resp) {
      throw new Error('No se recibió respuesta del servidor')
    }

    if (resp.status === 200 && resp.data?.success) {
      return {
        status: 'Ok',
        data: resp.data.data.templates || []
      }
    }

    return {
      status: 'Error',
      message: resp.data?.message || 'Error al obtener templates'
    }
  } catch (error: any) {
    console.error('Error en getTemplatesInfo:', error);
    return {
      status: 'Error',
      message: error.response?.data?.message || error.message || 'Error al conectar con el servidor'
    }
  }
}

const postSendTestEmail = async (emails: string, emailId: string) => {
  try {
    const resp = await api.post(emailSrv, {
      emails,
      emailId,
    }, authService.getToken())

    if (!resp) {
      throw new Error('No se recibió respuesta del servidor')
    }

    if (resp.status === 200 && resp.data?.success) {
      return {
        status: 'Ok',
        data: resp.data.data
      }
    }

    return {
      status: 'Error',
      message: resp.data?.message || 'Error al enviar email'
    }
  } catch (error: any) {
    console.error('Error en postSendTestEmail:', error);
    return {
      status: 'Error',
      message: error.response?.data?.message || error.message || 'Error al conectar con el servidor'
    }
  }
}

export const emailService = {
  getTemplatesInfo,
  postSendTestEmail
}